import api from "./api";

export const PACKS = [
  { lookup: "pack_10", sessions: 10, price: "$9.99", per: "$1.00", popular: false },
  { lookup: "pack_30", sessions: 30, price: "$24.99", per: "$0.83", popular: true },
];

export const startCheckout = async (lookup) => {
  const { data } = await api.post("/payments/checkout", { lookup_key: lookup, origin_url: window.location.origin });
  window.location.href = data.checkout_url;
};
